import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const BadgeContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	span {
		color: var(--alwaysWhiteColor);
	}

	&.hasChildren {
		position: relative;
		z-index: 1;

		transform: ${({ anchorOrigin }) => {
			if (anchorOrigin?.vertical === 'top' && anchorOrigin?.horizontal === 'left') {
				return 'translate(-50%, -50%)';
			} else if (anchorOrigin?.vertical === 'top' && anchorOrigin?.horizontal === 'right') {
				return 'translate(50%, -50%)';
			} else if (anchorOrigin?.vertical === 'bottom' && anchorOrigin?.horizontal === 'left') {
				return 'translate(-50%, 50%)';
			} else if (anchorOrigin?.vertical === 'bottom' && anchorOrigin?.horizontal === 'right') {
				return 'translate(50%, 50%)';
			}
		}};
	}

	&.blue {
		background-color: var(--blue);
	}

	&.red {
		background-color: var(--red);
	}

	&.yellow {
		background-color: var(--yellow);
	}

	&.green {
		background-color: var(--green);
	}

	&.black {
		background-color: var(--black-40);
	}

	&.teel {
		background-color: var(--teel);
	}

	&.white {
		background-color: var(--white);

		span {
			color: var(--blue);
		}
	}

	&.light {
		background-color: var(--black-10);

		span {
			color: var(--alert-description);
		}
	}

	&.dot-standart {
		width: 0.9rem;
		height: 0.9rem;
		border-radius: 50%;
	}

	&.dot-small {
		width: 0.6rem;
		height: 0.6rem;
		border-radius: 50%;
	}

	&.pill-standart {
		border-radius: 400px;
		height: 2.9rem;
		padding: 0.9rem 1.3rem;
		span {
			font-size: var(--paragraph3-font-size);
		}
	}

	&.pill-small {
		border-radius: 400px;
		height: 2.2rem;
		padding: 0.2rem 0.9rem;
		span {
			font-size: var(--caption-font-size);
		}
	}

	&.notifySize {
		border-radius: 400px;
		height: 1.4rem;
		padding: 0rem 0.5rem;
		span {
			font-size: 8px;
		}
	}
`;

export const ChildrenContainer = styled.div`
	position: ${({ $hasNotifyBadge }) => ($hasNotifyBadge ? 'absolute' : 'relative')};
`;
